import { useEffect, useState, FC } from "react";
import { Loader } from "components/ui";
import { useApi } from "hooks/api";
import { useAuth } from "hooks/auth";
import { useMutation } from "react-query";
import { OAuthToken } from "types/qbank/token";
import { Container, Typography } from "@mui/material";
import { useConnectorConfig } from "hooks/connectorConfig";

type AutoLoginProps = {
  children: React.ReactNode;
};

const AutoLogin: FC<AutoLoginProps> = ({ children }) => {
  const { connectorConfig } = useConnectorConfig();
  const { clientId, host, username, password, timeout } = connectorConfig;
  const { setAuth } = useAuth();
  const { setApi, loginWithClientId } = useApi();
  const [triedToLogin, setTriedToLogin] = useState<Boolean>(false);
  const [validParams, setValidParams] = useState<Boolean>(
    !clientId || !host || !username || !password
  );

  const { mutate: loginMutation } = useMutation(loginWithClientId, {
    onSuccess: (data: OAuthToken) => {
      setTriedToLogin(true);
      setAuth({ isLoggedIn: true, oAuthToken: data });
    },
    onError: (error: any) => {
      setAuth({ isLoggedIn: false });
      setTriedToLogin(true);
      setValidParams(false);
    },
  });

  useEffect(() => {
    const validData =
      !connectorConfig.host ||
      !connectorConfig.username ||
      !connectorConfig.password ||
      !connectorConfig.clientId;

    const autoLogin = () => {
      setApi({
        host: connectorConfig.host,
        client_id: connectorConfig.clientId,
      });
      loginMutation({
        host: connectorConfig.host,
        username: connectorConfig.username,
        password: connectorConfig.password,
        clientId: connectorConfig.clientId,
      });
    };

    if (!validData) {
      autoLogin();
    }
  }, [validParams, loginMutation, connectorConfig, setApi]);

  if (timeout) {
    return <>{children}</>;
  } else if (!validParams) {
    return (
      <Container sx={{ mt: 2 }}>
        <Typography>Contact your admin to setup connector correctly</Typography>
        <Typography>
          For more information look at our{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://support.qbank.se/hc/en-us/articles/115002445894-Getting-started"
          >
            documentation
          </a>
        </Typography>
      </Container>
    );
  } else if (triedToLogin) {
    return <>{children}</>;
  } else {
    return <Loader />;
  }
};

export default AutoLogin;
